import { PagedResult, Result, FloorplanItem } from "./../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    category: string;
    province: string;
    searchBy: string;
    culture: string;

    constructor() {
        this.keywords = '';
        this.category = '';
        this.province = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class FloorplanListingService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<FloorplanItem>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<FloorplanItem>>({
            url: `/api/search/SearchFloorplans`,
            method: "POST",
            data: payload
        });

        return result;
    }    
}
